<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="editor-container spacing-py-20 spacing-px-20">
    <b-loading isFullPage :active="isLoading" />
    <section class="mb-20">
      <span class="has-text-weight-semibold is-size-4 ml-5">{{
        General.DOCUMENT
      }}</span>
      <hr class="mt-5 mb-10" />
      <b-button
        :label="General.ATTACH"
        class="spacing-mx-5"
        :type="isContrast ? 'is-white' : 'is-green-lawn'"
        :disabled="isLoading || isLoadingUpload"
        @click="onSubmitDocument"
      />
      <b-button
        :label="General.CANCEL"
        class="spacing-mx-5"
        :type="isContrast ? 'is-white' : 'is-warning'"
        outlined
        @click="cancel"
      />
      <div class="is-flex mt-15">
        <b-icon
          icon="file-document-outline"
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          size="is-large"
        />
        <div class="is-flex is-flex-direction-column ml-5 flex-1">
          <span class="has-text-weight-semibold">{{ nameModel }}</span>
          <div>
            <span
              >{{ General.DOCUMENT_CODE }}:
              {{ documentCode || General.TEXTS.NUP_NOT_GENERATED }}
            </span>
          </div>
        </div>
        <b-button
          class="is-clickable"
          iconLeft="file-eye"
          size="is-medium"
          @click="viewDocument"
        >
          {{ General.TEXTS.VIEW_PRINT_VERSION }}
        </b-button>
      </div>
    </section>
    <main class="main">
      <section class="main-container" :class="{ horizontal: horizontal }">
        <section class="editor-preview">
          <div
            ref="doeForm"
            class="content-preview"
            :style="
              `width: ${page_format_mm[0] *
                responsiveZoom}mm; height: ${page_format_mm[1] *
                responsiveZoom}mm;`
            "
            @mousemove.once="mapInputs"
            @mouseup="mapInputs"
            @keyup="mapInputs"
          >
            <article
              v-for="(page, index) in replaceContent"
              :key="index"
              :style="stylePage(index)"
              class="page-show"
              v-html="sanitizedHtml(page)"
            />
          </div>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";
import { v4 as uuidv4 } from "uuid";

import { mapActions, mapGetters, mapMutations } from "vuex";
import ModalWarning from "@/views/App/ModalWarning.vue";
import { formatDate } from "@/utils/timeUtility";
import { sanitizedHtml } from "@/utils/dataManipulation";
import ViewEdowebModel from "@/views/App/ViewEdowebModel";
import ListUploadFiles from "@/components/ListUploadFiles";
import debounce from "lodash/debounce";

export default {
  name: "DoeModelView",

  props: {
    modelId: {
      type: String,
      default: ""
    },
    processId: {
      type: String,
      required: true,
      default: null
    },
    fileId: {
      type: String,
      default: ""
    },
    dispatchId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      App,
      General,
      sanitizedHtml,
      isLoading: false,
      isLoadingUpload: false,
      content: [
        `<header contenteditable="false" style="text-align: center"><img width="250px" alt="" src="${require("@/assets/images/LOGO-GOV.svg")}" /></header><br>`
      ],
      horizontal: false,
      zoom: 0.8,
      zoom_min: 0.1,
      zoom_max: 5.0,
      page_format_mm: [210, 297],
      display: "grid",
      mounted: false,
      documentInputList: [],
      nameModel: "",
      inputsValues: [],
      documentCode: "",
      updateFilesEdoweb: []
    };
  },

  computed: {
    ...mapGetters({
      editDocument: "getCurrentDocumentEdoweb",
      getCurrentUser: "getCurrentUser",
      getListUploadFiles: "getListUploadFiles",
      getCurrentDoeFile: "getCurrentDoeFile",
      updateEdowebFile: "getUpdateEdowebFile",
      isContrast: "isContrast"
    }),
    replaceContent() {
      const newContent = this.content.map(
        page => `<div style="margin: ${this.page_margins};">${page}</div>`
      );
      let inputCounter = 0;

      const getField = this.documentInputList.reduce((acc, field) => {
        acc[field.name] = field;
        return acc;
      }, {});

      this.content.forEach((page, index) => {
        page.match(/{(\w+)}/g)?.forEach(flagInput => {
          const field = getField[flagInput.replace(/[{}]/g, "")];
          newContent[index] = newContent[index].replace(
            flagInput,
            !this.fileId
              ? field.value
              : this.getInputValueHTML(field, inputCounter++)
          );
        });
      });

      return newContent;
    },
    pageRender() {
      let input_count = 0;

      return [...this.content].map(page => {
        const inputs = page.match(/({\w+})/gi) || [];
        inputs.map(input => {
          const value = this.inputsValues[input_count++] || "";
          page = page.replace(
            input,
            this.checkTable(value) ? "----TABLE----" : value
          );
        });
        return `<div style="margin: ${this.page_margins};">${page}</div>`;
      });
    },
    responsiveZoom() {
      return 1.2;
    },
    isMacLike: () => /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent)
  },

  watch: {
    updateEdowebFile(file) {
      if (file.sequence >= 0 && file.edoweb && file.s3Data)
        this.inputsValues[file.sequence] = JSON.stringify({
          table_file: file.s3Data
        });
    },
    getListUploadFiles: {
      handler(files) {
        const isPending = files.some(
          file => file.edoweb && file.status === "pending"
        );
        this.isLoadingUpload = isPending;
      },
      deep: true
    }
  },

  async beforeMount() {
    this.isLoading = true;

    if (this.fileId) {
      await this.getDOEDocumentFile(this.fileId);
      this.nameModel = this.getCurrentDoeFile.doe_document_model.name;
      this.content = this.getCurrentDoeFile.document_json.map(
        type => type.html
      );
      this.documentInputList = this.getCurrentDoeFile.document_json[0].inputs;
      this.page_margins = this.getCurrentDoeFile.document_json[0].page_margins;
      this.inputsValues = [...this.getCurrentDoeFile.document_json_inputs];
      this.documentCode = this.getCurrentDoeFile.doe_document_model.code;
    } else if (this.modelId) {
      await this.getModelDocumentEdoweb(this.modelId);
      this.nameModel = this.editDocument.name;
      this.content = this.editDocument.document_json.map(type => type.html);
      this.documentInputList = this.editDocument.document_json[0].inputs;
      this.page_margins = this.editDocument.document_json[0].page_margins;
      this.initializeInputValuesSize();
    }

    this.isLoading = false;
  },

  mounted() {
    this.mounted = true;
    setTimeout(() => {
      this.addValueTable();
    }, 1e3);
  },

  methods: {
    ...mapActions({
      getModelDocumentEdoweb: "getModelDocumentEdowebById",
      createDocumentDOEFile: "createDocumentDOEFile",
      editDocumentDOEFile: "editDocumentDOEFile",
      uploadTrigger: "uploadTrigger",
      getDOEDocumentFile: "getDOEDocumentFile"
    }),
    ...mapMutations(["clearListUploadFiles", "setListUploadFiles"]),
    drawVirtualDOM(html) {
      const tbody = document.createElement("tbody");
      tbody.innerHTML = html;
      return tbody.children;
    },
    addValueTable() {
      const list = document.querySelectorAll("[tindex]");
      list.forEach(el => {
        const index = el.getAttribute("tindex");
        if (index) {
          const value = this.getCurrentDoeFile.document_json_inputs[index];
          const name_file = JSON.parse(value).table_file.name;
          const actualFile = new File([""], name_file);
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(actualFile);
          el.files = dataTransfer.files;
          el.removeAttribute("tindex");
        }
      });
    },
    viewDocument() {
      this.$buefy.modal.open({
        parent: this,
        component: ViewEdowebModel,
        props: {
          html: this.pageRender
        },
        hasModalCard: true,
        trapFocus: true
      });
    },
    uploadFile(file) {
      this.setListUploadFiles([file]);
      this.snackQueue.open({
        id: "upload_files",
        parent: this,
        title: this.General.TEXTS.UPLOAD_QUANTITY.replace(
          "(QUANTITY)",
          this.getListUploadFiles.length
        ),
        closeAction: this.clearListUploadFiles,
        component: ListUploadFiles
      });
      this.uploadTrigger();
    },
    uploadEdowebFile: debounce(function(target, input, sequence) {
      const indexFile = this.updateFilesEdoweb.indexOf(
        file => file.index === sequence
      );
      const value = target.files?.[0];
      if (value?.name) {
        const fileData = {
          file: value,
          attachment_name: value.name,
          edoweb: true,
          type: input.type,
          sequence,
          file_index: uuidv4(),
          percentage: 0,
          status: "pending"
        };
        this.updateFilesEdoweb[sequence] = fileData;
        this.uploadFile(fileData);
        return JSON.stringify({
          table_file: {
            name: value.name,
            url_s3: ""
          }
        });
      } else {
        delete this.updateFilesEdoweb[indexFile];
        return "";
      }
    }, 1e3),
    saveValueField(ev, input, sequence) {
      const validation =
        input.type === "file" ? input.files[0]?.size : ev.target.value;

      if (validation) {
        const padFields = {
          date: target => formatDate(target.value),
          file: this.uploadEdowebFile
        };
        this.inputsValues[sequence] = padFields[input.type]
          ? padFields[input.type](ev.target, input, sequence)
          : ev.target.value;
      } else if (input?.type === "file") {
        const objectFromFile = JSON.parse(this.inputsValues[sequence]);

        const tempFile = new File(
          [""],
          objectFromFile.table_file?.name || "arquivo"
        );

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(tempFile);
        input.files = dataTransfer.files;
      } else this.inputsValues[sequence] = "";

      this.inputsValues = [...this.inputsValues];
    },
    mapInputs() {
      let inputs = this.$refs.doeForm.querySelectorAll(
        "input, textarea, select"
      );
      const actionsFields = {
        date: "change",
        file: "change",
        "select-one": "change",
        number: "keyup",
        text: "keyup",
        textarea: "keyup"
      };
      inputs = Array.from(inputs).filter(input => input);
      inputs?.forEach((input, index) =>
        input.addEventListener(actionsFields[input.type], ev =>
          this.saveValueField(ev, input, index)
        )
      );
    },
    initializeInputValuesSize() {
      let ocurrences = [];

      this.documentInputList.forEach(input => {
        this.content.forEach(page => {
          const regExp = RegExp(`{${input.name}}`, "g");
          ocurrences = ocurrences.concat(page.match(regExp));
        });
      });

      if (ocurrences.length)
        this.inputsValues = Array.from({ length: ocurrences.length }, () => "");
    },
    checkfieldRequired() {
      const fieldRequired = document.querySelectorAll("[required=true]");
      if (!fieldRequired.length) return true;
      const listFields = Array.from(fieldRequired);
      return !listFields.find(input => !input.value);
    },
    async onSubmitDocument() {
      this.isLoading = true;
      const checkFields = this.checkfieldRequired();
      if (checkFields) {
        let data = {
          document_json_inputs: this.inputsValues,
          process_id: this.processId,
          capacity_id: this.getCurrentUser.capacity.capacity_id,
          attachment_name: this.nameModel,
          file: null,
          editable: true,
          html_source: this.pageRender.join()
        };

        if (this.modelId)
          data = {
            ...data,
            doe_document_model_id: this.modelId
          };

        if (this.dispatchId)
          data = {
            ...data,
            dispatch_id: this.dispatchId
          };

        const status = this.fileId
          ? await this.editDocumentDOEFile({
              processFileId: this.fileId,
              fileDOE: data
            })
          : await this.createDocumentDOEFile(data);

        if (status) {
          this.$router.back();
        }
      } else {
        this.snackToast.open({
          message: `${this.General.EMPTY_FIELD_REQUIRED}.`,
          type: "is-danger",
          duration: 5000
        });
      }
      this.isLoading = false;
    },
    cancel() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: `${this.General.WARNING}!`,
          message: `${this.General.TEXTS.CONFIRM_CANCEL_DOC}?`,
          confirm: () => this.$router.back(),
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },
    stylePage(index) {
      return `transform: scale(${this.responsiveZoom}); top: ${
        index
          ? index * (this.page_format_mm[1] * this.responsiveZoom) +
            5.2 * (index + 1)
          : 5.2
      }mm;`;
    },
    checkTable(value) {
      try {
        return JSON.parse(value).table_file;
      } catch (error) {
        return false;
      }
    },
    getInputValueHTML(input, index) {
      const value = this.getCurrentDoeFile.document_json_inputs[index];

      if (input.type === "table") {
        return input.value.replace("type", `tindex="${index}" type`);
      }
      if (input.type === "textarea") {
        return input.value.replace("><", `>${value}<`);
      }
      if (input.type === "date") {
        return input.value.replace(
          "placeholder",
          `value="${value
            .split("/")
            .reverse()
            .join("-")}" placeholder`
        );
      }
      if (input.type) {
        return input.value.replace(
          "placeholder",
          `value="${value}" placeholder`
        );
      } else {
        return input.value
          .replace("selected", "")
          .replace(`value='${value}'`, `value='${value}' selected`);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.main {
  width: fit-content;
  min-width: 100%;
  font-size: 16px;
  overflow: auto;
  background-color: $color-2;
}
.editor-container {
  display: flex;
  flex: 1;
  flex-flow: column;
  background-color: $color-1;
  .main-container {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: flex-start;
    background-color: $color-2;

    .editor-preview {
      font-family: "Times New Roman", serif !important;
      font-size: 11pt !important;
      display: block;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      cursor: default;
      grid-column: 2;
      .content-preview {
        position: relative;
        margin: 0;
        padding: 0;
        min-width: 100%;
        color: #000;

        .page-show {
          position: absolute;
          width: 210mm;
          padding: 10mm 15mm;
          min-height: 297mm;
          box-sizing: border-box;
          transform-origin: left top;
          background: var(--page-background, white);
          box-shadow: var(
            --page-box-shadow,
            0 1px 3px 1px rgba(60, 64, 67, 0.15)
          );
          border: var(--page-border);
          border-radius: var(--page-border-radius);
          transition: left 0.3s, top 0.3s;
          overflow: hidden;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.page-show {
  input[type="number"] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>
